/**
 * フォーム関係-詳細表示用のフォームでのグリッドのフォームグループのコンポーネント
 */
import React, { ReactElement, useEffect, useMemo, useState } from "react";

import {
  Table,
  TableBody,
  TableContainer,
  makeStyles,
} from "@material-ui/core";

import { formStyles } from "../../../common/components/styles";

import { TRequiredKey } from "../../../common/components/types";

import { FONT, ThemeColorProps } from "../../../../constants/common";

import formStore from "../../../../store/formStore";

import GridHeading from "../../../common/components/atoms/GridHeading";
import ShowFormValueRow from "../atoms/ShowFormValueRow";

const useStyles = makeStyles(() => ({
  gridButton: {
    clear: "both",
    height: 35,
  },
  th: {
    fontFamily: FONT,
    fontWeight: 900,
    backgroundColor: "#fff",
    color: "#000!important",
    width: 263,
    borderBottom: "2px dotted #ddd",
    position: "relative",
  },
  td: {
    backgroundColor: "#fff",
    color: "#000!important",
    borderBottom: "2px dotted #ddd",
  },
  gridHeadingContainer: {
    position: "relative",
  },
}));

type Props = {
  formGroupNameId: number;
  requiredKey: TRequiredKey;
  colors: ThemeColorProps;
  terminalGridId: number | undefined;
};

const ShowGridGroup: React.FC<Props> = (props: Props) => {
  const { formGroupNameId, requiredKey, colors, terminalGridId } = props;

  const [groupData, setGroupData] = useState(
    formStore.getFormGroupData(formGroupNameId)
  );

  const formClasses = formStyles({
    color: colors.base,
    backgroundColor: colors.primary,
  });
  const classes = useStyles();

  useEffect(() => {
    const fn = () => {
      const data = formStore.getFormGroupData(formGroupNameId);
      setGroupData(data ? { ...data } : data);
    };
    formStore.addListener("grid", fn);

    return () => formStore.removeListener("grid", fn);
  }, [formGroupNameId]);

  const forms = useMemo(() => {
    const ret: ReactElement[] = [];
    if (!groupData) return ret;
    for (let i = 0; i < groupData.gridCount; i += 1) {
      ret.push(
        <>
          <div className={classes.gridHeadingContainer}>
            <GridHeading
              title={`${groupData.formGroupName}${String(i + 1)}`}
              key={`${groupData.formGroupName}${String(i + 1)}`}
            />
          </div>
          <TableContainer className={formClasses.tableContainer}>
            <Table>
              <TableBody>
                {groupData.forms.map((form) => (
                  <ShowFormValueRow
                    key={form.columnName}
                    columnName={form.columnName}
                    requiredKey={requiredKey}
                    terminalGridId={terminalGridId}
                    gridId={i}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      );
    }
    return ret;
    // classesは入れない
    // eslint-disable-next-line
  }, [formGroupNameId, groupData, requiredKey]);

  if (!groupData) return null;

  return <>{forms}</>;
};

export default ShowGridGroup;
